import React from 'react';
import { connect } from 'react-redux';
import Icon from './Icon';

import {
  setRowNumberOfColumns,
  setRowPadding,
  setRowMargin
} from '../actions/row-actions';

import styles from '../../../../stylesheet/css/header-builder/row-options.css';

let paddingRow = {};
let marginRow = {};

const getIcon = (id) => {
  switch(id) {
    case 1:
      return <Icon icon="divide-row-1" w="21px" h="15px" vb="0 0 21 15" fill="#a6a6a6"/>;
    case 2:
      return <Icon icon="divide-row-2" w="22px" h="15px" vb="0 0 22 15" fill="#a6a6a6"/>;
    case 3:
      return <Icon icon="divide-row-4" w="22px" h="15px" vb="0 0 22 15" fill="#a6a6a6"/>;
    case 4:
      return <Icon icon="divide-row-5" w="22px" h="15px" vb="0 0 22 15" fill="#a6a6a6"/>;
    case 11:
      return <Icon icon="divide-row-3" w="22px" h="15px" vb="0 0 22 15" fill="#a6a6a6"/>;
    case 6:
      return <Icon icon="divide-row-8" w="22px" h="15px" vb="0 0 22 15" fill="#a6a6a6"/>;
    case 7:
      return <Icon icon="divide-row-6" w="22px" h="15px" vb="0 0 22 15" fill="#a6a6a6"/>;
    case 8:
      return <Icon icon="divide-row-7" w="22px" h="15px" vb="0 0 22 15" fill="#a6a6a6"/>;
    case 12:
      return <Icon icon="divide-row-9" w="22px" h="15px" vb="0 0 22 15" fill="#a6a6a6"/>;
    case 10:
      return <Icon icon="divide-row-10" w="22px" h="15px" vb="0 0 22 15" fill="#a6a6a6"/>;
    case 'margin-padding':
      return <Icon icon="margin-padding-container" w="238px" h="164px" vb="0 0 238 164" fill="#6b6b6b"/>;
    default:
      return <Icon icon="divide-row-1" w="22px" h="15px" vb="0 0 22 15" fill="#f44242"/>;
  }
}

const renderIcon = (n, columns, onColumnsNoChange) => {
  let cls = styles.colnoIcon;
  let icon = n;

  if (n === columns.length) {
    cls += ' ' + styles.selected;
  }

  const handleOnClick = () => {
    const num = columns.filter(c => c.elements.length > 0).length - n;

    if (num > 0) {
      if (!confirm(`${num} non empty column${num > 1 ? 's' : ''} will be removed, are you sure?`)) {
        return;
      }
    }

    onColumnsNoChange(n);
  };

  return (
    <div key={n} className={cls} onClick={handleOnClick}>
      {getIcon(n)} 
    </div>
  );
};

const renderIcons = (start, end, columns, onColumnsNoChange) => {
  const result = [];

  for (let i = start; i <= end; i++) {
    result.push(renderIcon(i, columns, onColumnsNoChange));
  }

  return result;
};

const renderDirection = ( i, indexDir, values, functionChange ) => {
  const handleElementChange = e => functionChange(e.target.id, e.target.value);
  const handleElementKeyDown = e => onInputKeyDown( e, functionChange );
  return (
    <input key={i} onBlur={onInputBlur} onKeyDown={handleElementKeyDown} type="text" className={styles.numberBox + ' ' + styles[ indexDir ]} value={ values.hasOwnProperty( indexDir ) ? values[ indexDir ] : '0' } onChange={ handleElementChange } id={ indexDir } />
  );
};

const renderDirections = ( type, values, functionChange ) => {
  const result = [];
  const list = [ 'Top', 'Right', 'Bottom', 'Left' ];
  values = ( typeof( values ) == 'object' ) ? values : {};
  for ( let i = 0; i < list.length; i++ ) {
    let indexDir = type + list[i];
    let label = indexDir.replace( type, '' ).toUpperCase();
    result.push( renderDirection( i, indexDir, values, functionChange ) );
  }
  return result;
};

const checkEmptyObject = ( obj ) => {
  for ( var key in obj ) {
    if ( obj.hasOwnProperty( key ) )
      return false;
  }
  return true;
};

const onInputKeyDown = (e, functionChange) => {
  var keyCode = e.keyCode;

  if (keyCode == 38 || keyCode == 40) {
    /* Arrow up and down */
    e.preventDefault();
    var val = parseInt(e.target.value);

    if(val || val == 0){
      switch (keyCode) {
        case 38:
          val = val+1;
          e.target.value=val;
        break;

        case 40:
          if (val <= 0) {}
          else{
            val = val-1;
            e.target.value = val;
          }
        break;
      }
    }
    else{
      e.target.value=0;
    }

    functionChange(e.target.id, e.target.value);

    return true;
  }

  if (keyCode == 37 || keyCode == 39 || (keyCode >= 48 && keyCode <= 57) || keyCode == 8 || keyCode == 46 ) {}
  else{e.preventDefault(); return false;}
};

const onInputBlur = (e) => {
  var val = e.target.value;
  if (val == '') {
    e.target.value=0;
  }
};

const setElementValues = (elementRow, rowId, id, value ) => {
  let elementRowTemp = ( elementRow.hasOwnProperty( rowId ) ) ? elementRow[ rowId ] : {};
  elementRowTemp = ( typeof( elementRowTemp ) == 'object' ) ? elementRowTemp : {};
  elementRowTemp[ id ] = value;
  return elementRowTemp;
};

export const RowOptions = ({
  device, id, columns,
  onColumnsNoChange,
  onPaddingChange,
  onMarginChange,
  options = {}
}) => {

  const { margin, padding } = options;

  if ( checkEmptyObject( paddingRow ) && ! paddingRow.hasOwnProperty( id ) ) {
    paddingRow[ id ] = padding;
  }

  if ( checkEmptyObject( marginRow ) && ! marginRow.hasOwnProperty( id )  ) {
    marginRow[ id ] = margin;
  }

  return (
    <div className={styles.colPanel}>
      <header>Layout</header>
      <div>
        {renderIcons(1, 3, columns, onColumnsNoChange)}
        {renderIcons(11, 11, columns, onColumnsNoChange)}
        {renderIcons(4, 4, columns, onColumnsNoChange)}
        {renderIcons(7, 7, columns, onColumnsNoChange)}
        {renderIcons(8, 8, columns, onColumnsNoChange)}
        {renderIcons(6, 6, columns, onColumnsNoChange)}
        {renderIcons(12, 12, columns, onColumnsNoChange)}
        {renderIcons(10, 10, columns, onColumnsNoChange)}
      </div>
      <div className={styles.box}>
        { getIcon( 'margin-padding' ) }
        { renderDirections( 'padding', padding, onPaddingChange ) }
        { renderDirections( 'margin', margin, onMarginChange ) }
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onColumnsNoChange(numberOfColumns) {
      const { device, id: rowId } = ownProps;
      dispatch(setRowNumberOfColumns({ device, rowId, numberOfColumns }));
    },
    onPaddingChange(id, value) {
      const { device, id: rowId } = ownProps;
      paddingRow = ( typeof( paddingRow ) == 'object' ) ? paddingRow : {};
      let paddingRowTemp = setElementValues( paddingRow, rowId, id, value );
      paddingRow[ rowId ] = paddingRowTemp;
      dispatch(setRowPadding({ device, rowId, value: paddingRowTemp }));
    },
    onMarginChange(id, value) {
      const { device, id: rowId } = ownProps;
      marginRow = ( typeof( marginRow ) == 'object' ) ? marginRow : {};
      let marginRowTemp = setElementValues( marginRow, rowId, id, value );
      marginRow[ rowId ] = marginRowTemp;
      dispatch(setRowMargin({ device, rowId, value: marginRowTemp }));
    },
  };
};

export default connect(
  null,
  mapDispatchToProps
)(RowOptions);



// WEBPACK FOOTER //
// ./app/header-builder/components/RowOptions.js